module.exports = __webpack_public_path__ + "static/Underdown-extra-8440fb92095fccedb54a48619c54f60e.webp";